import { createI18n } from 'vue-i18n';
import messages from '@/lang/message';

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'th',
  messages,
});
